import { Provider } from '@angular/core';

import { MomoManageVacationsRepositoryImpl } from '@app/data/repositories/manage-vacations/momo/momo-manage-vacations.repository';
import { MOMO_MANAGE_VACATIONS_REPOSITORY } from '@app/domain/repositories/manage-vacations/momo/momo-manage-vacations.repository.contract';

export const momoManageVacationsRepositoryProvider: Provider = {
  provide: MOMO_MANAGE_VACATIONS_REPOSITORY,
  useClass: MomoManageVacationsRepositoryImpl
};
